import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    flip: false,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    width: '100%',
    direction: 'ltr'
  },
  chartContainer: {
    display: 'flex',
    width: '100%'
  },
  yAxis: {
    flip: false,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-end',
    paddingRight: theme.spacing(2),
    flexShrink: 0,
    width: '25%',
    [theme.breakpoints.down('xs')]: {
      width: '36%'
    },
    [theme.breakpoints.only('sm')]: {
      width: '18%'
    },
    [theme.breakpoints.only('lg')]: {
      width: '20%'
    },
    [theme.breakpoints.up('xl')]: {
      width: '17%'
    }
  },
  yAxisLabel: {
    width: '50%'
  },
  chartArea: {
    flip: false,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    marginRight: '9%'
  },
  bar: {
    height: theme.spacing(4),
    margin: theme.spacing(0.75, 0)
  },
  xAxis: {
    flip: false,
    display: 'flex',
    justifyContent: 'space-around',
    height: theme.spacing(5),
    marginRight: '9%',
    marginLeft: '25%',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '36%'
    },
    [theme.breakpoints.only('sm')]: {
      marginLeft: '18%'
    },
    [theme.breakpoints.only('lg')]: {
      marginLeft: '20%'
    },
    [theme.breakpoints.up('xl')]: {
      marginLeft: '17%'
    }
  }
}));

const SKELETON_BAR_WIDTHS = ['60%', '30%', '85%', '55%', '35%'];

const BenchOverAllocationChartSkeleton = () => {
  const classes = useStyles();

  const skeletonRows = Array.from({ length: 5 }, (_, i) => `skeleton-row-${i}`);
  const xAxisTicks = Array.from({ length: 7 }, (_, i) => `x-axis-${i}`);

  return (
    <div className={classes.root}>
      <div className={classes.chartContainer}>
        <div className={classes.yAxis}>
          {skeletonRows.map(key => (
            <Skeleton
              key={key}
              className={classes.yAxisLabel}
              variant="text"
              height={20}
            />
          ))}
        </div>
        <div className={classes.chartArea}>
          {skeletonRows.map((key, index) => (
            <Skeleton
              key={key}
              className={classes.bar}
              width={SKELETON_BAR_WIDTHS[index]}
              variant="rect"
            />
          ))}
        </div>
      </div>
      <div className={classes.xAxis}>
        {xAxisTicks.map(key => (
          <Skeleton key={key} variant="text" width={15} height={20} />
        ))}
      </div>
    </div>
  );
};

export default BenchOverAllocationChartSkeleton;
